<template>
    <div class="fixed xl:hidden lg:hidden md:hidden w-full surface-0 px-3 shadow-2 z-4 top-0">
        <div class="flex w-full flex-row">
            <div class="flex justify-content-center align-items-center">
                <Button class="flex mr-2" rounded icon="pi pi-arrow-left" @click="goBack()" severity="secondary" size="small" />
            </div>
            <slot name="body"></slot>
        </div>
        <!-- <div v-if="can_pay && progress>0" class="absolute w-full bottom-0 left-0 right-0" style="height:2px">
            <div class="absolute bg-primary bottom-0 left-0 right-0" style="height:2px" :style="'width:'+progress+'%'"></div>
        </div> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            
        }
    },
    methods: {
        goBack() {
            try { this.$router.go(-1) } 
            catch (e) { this.$router.push({ path: '/' }) }
        },
    }
}
</script>
